export default "__VITE_ASSET__45ce4dfe__"